exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-note-template-tsx": () => import("./../../../src/templates/noteTemplate.tsx" /* webpackChunkName: "component---src-templates-note-template-tsx" */),
  "component---src-templates-page-template-tsx": () => import("./../../../src/templates/pageTemplate.tsx" /* webpackChunkName: "component---src-templates-page-template-tsx" */),
  "component---src-templates-reading-template-tsx": () => import("./../../../src/templates/readingTemplate.tsx" /* webpackChunkName: "component---src-templates-reading-template-tsx" */)
}

